import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const SoundSettingsTab = ({
  soundSettings,
  uploadingSound,
  onSoundUpload,
  onPlaySound
}) => {
  const soundButtons = [
    { id: 'awful', label: '🚫 MAJOR ISSUES SOUND (LOWEST SCORE)', color: 'red', sound: soundSettings?.awful_sound },
    { id: 'bad', label: '🔧 NEEDS ATTENTION SOUND', color: 'orange', sound: soundSettings?.bad_sound },
    { id: 'good', label: "👌 IT'S OK SOUND", color: 'yellow', sound: soundSettings?.good_sound },
    { id: 'excellent', label: '🏆 EXCEPTIONAL SOUND (HIGHEST SCORE)', color: 'green', sound: soundSettings?.excellent_sound }
  ];

  return (
    <div className="space-y-4">
      <h2 className="text-3xl text-red-600 mb-4" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '4px', fontWeight: '400' }}>
        MANAGE REVIEW SOUND EFFECTS
      </h2>
      <p className="text-gray-900 text-lg mb-6" style={{ letterSpacing: '1px' }}>
        Upload custom sound effects for each review rating button.
      </p>
      
      <div className="grid gap-6">
        {soundButtons.map(({ id, label, color, sound }) => (
          <div key={id} className="bg-white p-6 rounded border-4 border-black">
            <h3 className={`text-xl font-bold text-${color}-600 mb-2`} style={{ letterSpacing: '1px' }}>{label}</h3>
            <p className="text-sm text-gray-600 mb-3">Current: {sound}</p>
            <div className="flex gap-3">
              <Label htmlFor={`${id}-upload`} className="cursor-pointer">
                <div className="px-4 py-2 bg-blue-500 text-white rounded border-2 border-black font-bold hover:bg-blue-600 inline-block">
                  {uploadingSound === id ? 'Uploading...' : 'Upload New Sound'}
                </div>
                <Input 
                  id={`${id}-upload`} 
                  type="file" 
                  accept="audio/*" 
                  className="hidden"
                  onChange={(e) => e.target.files[0] && onSoundUpload(id, e.target.files[0])}
                  disabled={uploadingSound === id} 
                />
              </Label>
              <Button 
                onClick={() => onPlaySound(sound)} 
                className="bg-green-500 hover:bg-green-600 text-white border-2 border-black"
              >
                🔊 Test Sound
              </Button>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-yellow-50 border-4 border-yellow-400 rounded">
        <p className="text-sm text-gray-700 font-bold">ℹ️ Sound files should be less than 5MB. Supported: MP3, WAV, OGG, etc.</p>
      </div>
    </div>
  );
};
